export default __webpack_public_path__ + "bf8319728209d1919d8733be350b038f.png";